import styled from "styled-components";

interface SectionProps {
  hasCollapse: boolean;
}

export const Section = styled.section<SectionProps>`
  display: ${({ hasCollapse }) => (hasCollapse ? "flex" : "none")};
  flex-direction: column;
  height: calc(100vh - 112px);
  min-width: 260px;
  padding: 10px 15px 150px 15px;
  overflow-y: auto;
  background: #f4f6f8;
  @media (max-width: 768px) {
    padding: 0px 2px 150px 2px;
    min-width: 53px;
  }
`;

export const ContainerMobile = styled.div`
display: flex;
flex-direction: column;
gap: 0px;
p{
  font-size: 10px;
  color: #2c2c2c;
  display: none;
}
@media (min-width: 769px) {
  display: none;
}
`

export const Collapse = styled.div<SectionProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: 26px;
  position: absolute;
  top: 130px;
  left: ${({ hasCollapse }) => (hasCollapse ? "260px" : "0")};
  cursor: pointer;
  width: 50px;
  height: 50px;
  z-index: 999;
  shape-outside: circle(50% at 30%);
  clip-path: circle(50% at 0%);
  background: #355B94;
  @media (min-width: 1250px) {
    display: none;
  }
  @media (max-width: 768px) {
    display: none;
  }
`;
export const SelectWrapper = styled.div`
  padding: 0 8px;
`;

export const Divider = styled.hr`
  margin: 12px auto;
  width: 100%;
  height: 0.1px;
  background-color: #fafafa;
  @media (max-width: 768px) {
    display: none;
  }
`;

export const HiddenDivider = styled.div`
  margin: 6px auto;
  width: 100%;
  background-color: transparent;
`;

export const EmailFieldTitle = styled.h3`
  font-size: 0.8rem;
  font-family: "Archivo-Bold";
  color: #a4a4a4;
`;

export const EmailFieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  @media (max-width: 768px) {
     p:last-child {
      font-size: 8px;
    }
  }
`;
export const TitleSection = styled.p`
  font-size: 1rem;
  font-family: "Archivo-Bold";
  color: #2c2c2c;
   @media (max-width: 768px) {
    font-size: 8px;
    text-align: center;
    margin-top: 5px;
    span {
      display: none;
    }
  }
`;
export const AddField = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  margin-bottom: 10px;
  @media (max-width: 768px) {
    display: none;
  }
`;
interface DropdownProps {
  isExpanded: boolean;
}
export const Dropdown = styled.div<DropdownProps>`
  transform: ${({ isExpanded }) => (isExpanded ? "rotate(180deg)" : "")};
  transition: transform 0.3s;
`;
interface VisibleProps {
  visible: boolean;
}
export const Visible = styled.div<VisibleProps>`
  visibility: ${(props) => (props.visible ? "visible" : "hidden")};
  max-height: ${(props) => (props.visible ? "1000px" : "0")};
  transition: max-height 0.2s ease, visibility 0.3s ease;

  > * {
    opacity: ${(props) => (props.visible ? 1 : 0)};
    transition: opacity 0.3s ease;
  }
  @media (max-width: 768px) {
    display: none;
  }
`;
export const RadioWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

interface ButtonAddFieldProps {
  saved?: boolean;
}
export const ButtonAddField = styled.button<ButtonAddFieldProps>`
  display: flex;
  align-items: center;
  gap: 5px;
  border-radius: 99px;
  background-color: ${({ saved }) => (saved ? "#77EC84" : "#355B94")};
  opacity: 0.4;
  pointer-events: none;
  border: none;
  text-transform: uppercase;
  padding: 10px;
  font-family: "Archivo-Regular";
  color: #fff;
  font-size: 12px;

  cursor: ${({ saved }) => (saved ? "not-allowed" : "pointer")};
  &:hover {
    transition: all 0.2s;
    background-color: ${({ saved }) => (saved ? "" : "#32568c")};
  }
  /* opacity: 0.4; */
  pointer-events: none;
`;

export const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
  gap: 30px;
  width: 375px;
  height: 200px;

  h2 {
    color: #2c2c2c;
  }
`;

export const ModalWrapperInput = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  color: #2c2c2c;

  width: 100%;
  gap: 5px;
`;
export const ModalInput = styled.input`
  width: 100%;
  padding: 5px 5px 5px 10px;
  height: 30px;
  color: #2c2c2c;
  font-size: 16px;
  border: 1px solid #2c2c2c;
  border-radius: 99px;
  &:focus {
    outline: none;
    caret-color: #2c2c2c;
    border: 2px solid #2c2c2c;
  }
`;
export const ModalWrapperButton = styled.div`
  display: flex;
  width: 100%;
  margin-top: 5px;
  gap: 10px;
  justify-content: space-between;
`;
interface ModalButtonProps {
  backgroundColor: string;
  hoverBackgroundColor: string;
  color: string;
}
export const ModalButton = styled.button<ModalButtonProps>`
  background-color: ${(props) => props.backgroundColor};
  border: none;
  padding: 10px 20px;
  border-radius: 99px;
  color: ${(props) => props.color ? props.color : "#fff"};
  cursor: pointer;
  &:hover {
    transition: all 0.2s;
    background-color: ${(props) => props.hoverBackgroundColor};
  }
`;
export const ModalFormButton = styled.button<ModalButtonProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => props.backgroundColor};
  border: none;
  margin-left: 5px;
  width: 30px;
  height: 30px;
  font-size: 20px;
  border-radius: 99px;
  color: #fff;
  cursor: pointer;
  &:hover {
    transition: all 0.2s;
    background-color: ${(props) => props.hoverBackgroundColor};
  }
`;
export const ModalFormContent = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 340px;
`;

interface FormButtonProps {
  checked: boolean;
}
export const FormWrapper = styled.div<FormButtonProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 6px 8px;
  border-radius: 99px;
  background-color: ${({ checked }) => (checked ? "#77EC8450" : "transparent")};

  &:hover {
    transition: all 0.2s;
    background-color: ${({ checked }) => (!checked ? "#77EC8470" : null)};
  }
`;

export const FormOptions = styled.div`
  display: flex;
  flex-direction: row;
`;

export const FormButton = styled.div`
  color: #2c2c2c;
  margin-left: 5px;
  cursor: pointer;
`;

export const TitleTextFormModal = styled.h4`
  color: #2c2c2c;
  font-family: "Archivo-Bold";
`;

export const HelpText = styled.span`
  display: flex;
  flex-direction: column;
  
  color: #2c2c2c;
  font-size: 18px;
  font-family: "Archivo-Bold";
`;
export const Disable = styled.div`
  pointer-events: none;
  opacity: 0.4;
`;
